// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/create_experiment_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/create_experiment_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_request: GenFile = /*@__PURE__*/
  fileDesc("CkdxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3JlYXRlX2V4cGVyaW1lbnRfcmVxdWVzdC5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIosBChdDcmVhdGVFeHBlcmltZW50UmVxdWVzdBIgChNuZXdfZXhwZXJpbWVudF9uYW1lGAEgASgJSACIAQESHwoSaW5zdHJ1bWVudF9kYXRhX2lkGAIgASgJSAGIAQFCFgoUX25ld19leHBlcmltZW50X25hbWVCFQoTX2luc3RydW1lbnRfZGF0YV9pZGIGcHJvdG8z");

/**
 * Rpc request to initialize a new experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CreateExperimentRequest
 */
export type CreateExperimentRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.CreateExperimentRequest"> & {
  /**
   * User-assigned name for the new experiment
   *
   * @generated from field: optional string new_experiment_name = 1;
   */
  newExperimentName?: string;

  /**
   * If provided, the unique id (UUID) of instrument
   * data associated with the new experiment
   *
   * @generated from field: optional string instrument_data_id = 2;
   */
  instrumentDataId?: string;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CreateExperimentRequest.
 * Use `create(CreateExperimentRequestSchema)` to create a new message.
 */
export const CreateExperimentRequestSchema: GenMessage<CreateExperimentRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_request, 0);

